const positionSubscriptionApi = '/position-subscription';

export const createCandidatePositionSubscriptionAPIPath = () =>
  `${positionSubscriptionApi}/candidate`;

export const confirmCandidatePositionSubscriptionAPIPath = () =>
  `${positionSubscriptionApi}/candidate/confirm`;

export const createReferralPositionSubscriptionAPIPath = () =>
  `${positionSubscriptionApi}/referral`;

export const resubscribeReferralPositionSubscriptionAPIPath = () =>
  `${positionSubscriptionApi}/referral/resubscribe`;

export const getPositionSubscriptionAPIPath = () =>
  `${positionSubscriptionApi}`;

export const updatePositionSubscriptionAPIPath = () =>
  `${positionSubscriptionApi}/update`;

export const unsubscribePositionSubscriptionAPIPath = () =>
  `${positionSubscriptionApi}/unsubscribe`;
